var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 32,
    viewBox: "0 0 130 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3621_9866)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.5227 13.8002H28.2756C27.8331 12.8802 26.8676 12.1602 25.3791 12.1602C23.609 12.1602 21.9194 13.4802 21.9194 16.0002C21.9194 18.1602 23.3676 19.8402 25.4596 19.8402C26.9078 19.8402 27.9136 19.1202 28.3963 18.0402H29.6434C28.8791 19.6802 27.5917 20.8402 25.4193 20.8402C22.6837 20.8402 20.793 18.7602 20.793 16.0002C20.793 13.2402 22.8044 11.2002 25.4193 11.2002C27.8733 11.2002 29.04 12.6402 29.5227 13.8002Z",
    fill: "black",
    fillOpacity: 0.87
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4023 19.8402C38.454 19.8402 40.023 18.2002 40.023 16.0002C40.023 13.8002 38.5747 12.1602 36.4023 12.1602C34.3909 12.1602 32.8219 13.7602 32.8219 16.0002C32.8219 18.2402 34.3909 19.8402 36.4023 19.8402ZM36.4023 11.2002C39.3391 11.2002 41.1092 13.4802 41.1092 16.0002C41.1092 18.5202 39.0977 20.8002 36.4023 20.8002C33.1438 20.8002 31.6553 18.2402 31.6553 16.0002C31.6955 13.4002 33.6667 11.2002 36.4023 11.2002Z",
    fill: "black",
    fillOpacity: 0.87
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7692 13.2005C44.7692 13.6805 44.8094 14.6005 44.8094 15.0805V20.4805H43.8037V11.4805H44.8094L47.706 15.8405C48.7519 17.4005 49.3151 18.2805 49.5967 18.8005H49.637C49.5967 18.2805 49.5967 17.3605 49.5967 16.8805V11.4805H50.6025V20.5205H49.5967L46.7002 16.1605C45.4933 14.3605 45.0911 13.7605 44.7692 13.2005Z",
    fill: "black",
    fillOpacity: 0.87
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6432 13.3201C57.5225 12.6401 56.9995 12.1201 56.1547 12.1201C55.2294 12.1201 54.6662 12.7201 54.6662 13.4801C54.6662 14.3201 55.3099 14.7601 56.3559 15.0801C58.3673 15.6801 59.011 16.6401 59.011 18.0401C59.011 19.4401 58.0455 20.7601 56.1949 20.7601C54.7064 20.7601 53.5398 19.9601 53.1777 18.2801H54.3846C54.626 19.2001 55.2294 19.8001 56.2352 19.8001C57.3616 19.8001 57.9248 18.9201 57.9248 18.0801C57.9248 17.0401 57.2811 16.4801 56.034 16.0801C54.3846 15.5601 53.58 14.7601 53.58 13.4401C53.58 12.1201 54.626 11.1201 56.1547 11.1201C57.6834 11.1201 58.6087 12.0801 58.8098 13.2801H57.6432V13.3201Z",
    fill: "black",
    fillOpacity: 0.87
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2347 12.4805H60.9014V11.4805H66.6542V12.4805H64.3209V20.5205H63.2347V12.4805Z",
    fill: "black",
    fillOpacity: 0.87
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7752 12.4805H69.9534V15.3205H73.6142V16.3205H69.9534V19.4805H73.8959V20.4805H68.8672V11.4805H73.7752V12.4805Z",
    fill: "black",
    fillOpacity: 0.87
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5908 11.4805H77.677V19.5205H81.6195V20.5205H76.5908V11.4805Z",
    fill: "black",
    fillOpacity: 0.87
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.832 11.4805H84.9182V19.5205H88.8607V20.5205H83.832V11.4805Z",
    fill: "black",
    fillOpacity: 0.87
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.1249 17.1205H96.3432L95.418 14.5605C95.2168 14.0805 94.9754 13.2405 94.8145 12.7205H94.7341C94.5731 13.2805 94.2915 14.0405 94.0904 14.5605L93.1249 17.1205ZM94.3318 11.4805H95.2973L98.8375 20.5205H97.6306L96.7053 18.0805H92.7628L91.8376 20.5205H90.6709L94.3318 11.4805Z",
    fill: "black",
    fillOpacity: 0.87
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.695 12.4805H99.3613V11.4805H105.114V12.4805H102.781V20.5205H101.695V12.4805Z",
    fill: "black",
    fillOpacity: 0.87
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.412 11.4805H107.326V20.5205H108.412V11.4805Z",
    fill: "black",
    fillOpacity: 0.87
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.774 19.8402C117.826 19.8402 119.395 18.2002 119.395 16.0002C119.395 13.8002 117.947 12.1602 115.774 12.1602C113.763 12.1602 112.194 13.7602 112.194 16.0002C112.194 18.2402 113.723 19.8402 115.774 19.8402ZM115.774 11.2002C118.711 11.2002 120.481 13.4802 120.481 16.0002C120.481 18.5202 118.47 20.8002 115.774 20.8002C112.516 20.8002 111.027 18.2402 111.027 16.0002C111.027 13.4002 113.039 11.2002 115.774 11.2002Z",
    fill: "black",
    fillOpacity: 0.87
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.142 13.2005C124.142 13.6805 124.182 14.6005 124.182 15.0805V20.4805H123.177V11.4805H124.182L127.079 15.8405C128.125 17.4005 128.688 18.2805 128.97 18.8005H129.01C128.97 18.2805 128.97 17.3605 128.97 16.8805V11.4805H129.976V20.5205H128.93L126.033 16.1605C124.826 14.3605 124.424 13.7605 124.142 13.2005Z",
    fill: "black",
    fillOpacity: 0.87
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.26471 16C2.26471 7.53454 8.76471 0.64 17 0.0290909C16.6176 0.0290909 16.2353 0 15.8529 0C7.11765 0 0 7.15636 0 16C0 24.8436 7.11765 32 15.8529 32C16.2353 32 16.6176 31.9709 17 31.9709C8.76471 31.36 2.26471 24.4655 2.26471 16Z",
    fill: "black",
    fillOpacity: 0.87
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.73733 15.9709C6.73733 9.6368 11.7097 4.46489 18 4.02906C17.7005 4 17.4309 4 17.1313 4C10.4516 4 5 9.3753 5 16C5 22.6247 10.4217 28 17.1313 28C17.4309 28 17.7005 28 18 27.9709C11.7097 27.477 6.73733 22.3051 6.73733 15.9709Z",
    fill: "black",
    fillOpacity: 0.87
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2145 16C10.2145 11.7818 13.6401 8.32 18 8.02909C17.8131 8.02909 17.5952 8 17.4083 8C12.7682 8 9 11.5782 9 16C9 20.4218 12.7682 24 17.4083 24C17.5952 24 17.8131 24 18 23.9709C13.6401 23.68 10.2145 20.2182 10.2145 16Z",
    fill: "black",
    fillOpacity: 0.87
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3621_9866"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 130,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.cef39e0ee826c11dce7c849a1abf2310.svg";
export { ForwardRef as ReactComponent };